const { default: CONSTANTS } = require("./CONSTANTS");

const actions = {
  getSendOTPToUser: (payload) => ({
    type: CONSTANTS.GET_LOGIN_SEND_OTP_TO_USER,
    payload,
  }),
  setSendOTPToUser: (payload) => ({
    type: CONSTANTS.SET_LOGIN_SEND_OTP_TO_USER,
    payload,
  }),

  checkOTP: (payload) => ({
    type: CONSTANTS.GET_LOGIN_CHECK_OTP,
    payload,
  }),

  getActiveBenefits: (payload) => ({
    type: CONSTANTS.GET_MAIN_ACTIVE_BENEFITS,
    payload,
  }),
  setActiveBenefits: (payload) => ({
    type: CONSTANTS.SET_MAIN_ACTIVE_BENEFITS,
    payload,
  }),

  getMyPolicies: (payload) => ({
    type: CONSTANTS.GET_MAIN_MY_POLICIES,
    payload,
  }),
  setMyPolicies: (payload) => ({
    type: CONSTANTS.SET_MAIN_MY_POLICIES,
    payload,
  }),

  getMyDoctor: (payload) => ({
    type: CONSTANTS.GET_MAIN_MY_DOCTOR,
    payload,
  }),
  setMyDoctor: (payload) => ({
    type: CONSTANTS.SET_MAIN_MY_DOCTOR,
    payload,
  }),

  getMyManagerByPolicyId: (payload) => ({
    type: CONSTANTS.GET_MAIN_MY_MANAGER_BYPOLICYID,
    payload,
  }),
  setMyManagerByPolicyId: (payload) => ({
    type: CONSTANTS.SET_MAIN_MY_MANAGER_BYPOLICYID,
    payload,
  }),

  getPlannedVisitsDoctor: (payload) => ({
    type: CONSTANTS.GET_MAIN_PLANNED_VISITS_DOCTOR,
    payload,
  }),
  setPlannedVisitsDoctor: (payload) => ({
    type: CONSTANTS.SET_MAIN_PLANNED_VISITS_DOCTOR,
    payload,
  }),

  getPlannedVisitsServiceCenter: (payload) => ({
    type: CONSTANTS.GET_MAIN_PLANNED_VISITS_SERVICE_CENTER,
    payload,
  }),
  setPlannedVisitsServiceCenter: (payload) => ({
    type: CONSTANTS.SET_MAIN_PLANNED_VISITS_SERVICE_CENTER,
    payload,
  }),
  getChangePassword: (payload) => ({
    type: CONSTANTS.GET_MAIN_CHANGE_PASSWORD,
    payload,
  }),
  setChangePassword: (payload) => ({
    type: CONSTANTS.SET_MAIN_CHANGE_PASSWORD,
    payload,
  }),

  getPersonalInfo: (payload) => ({
    type: CONSTANTS.GET_MAIN_PERSONALINFO,
    payload,
  }),
  setPersonalInfo: (payload) => ({
    type: CONSTANTS.SET_MAIN_PERSONALINFO,
    payload,
  }),

  getInsuranceProductsByUser: (payload) => ({
    type: CONSTANTS.GET_MAIN_INSURANCE_PRODUCTS_BY_USER,
    payload,
  }),
  setInsuranceProductsByUser: (payload) => ({
    type: CONSTANTS.SET_MAIN_INSURANCE_PRODUCTS_BY_USER,
    payload,
  }),

  getRemunerationsDashbord: (payload) => ({
    type: CONSTANTS.GET_MAIN_REMUNERATIONS_DASHBOARD,
    payload,
  }),
  setRemunerationsDashbord: (payload) => ({
    type: CONSTANTS.SET_MAIN_REMUNERATIONS_DASHBOARD,
    payload,
  }),

  getdashboardAppeals: (payload) => ({
    type: CONSTANTS.GET_MAIN_DASHBOARD_APPEALS,
    payload,
  }),
  setdashboardAppeals: (payload) => ({
    type: CONSTANTS.SET_MAIN_DASHBOARD_APPEALS,
    payload,
  }),

  getDeleteReservation: (payload) => ({
    type: CONSTANTS.GET_MAIN_DELETE_RESERVATION,
    payload,
  }),
  setDeleteReservation: (payload) => ({
    type: CONSTANTS.SET_MAIN_DELETE_RESERVATION,
    payload,
  }),

  setServiceCenterUpdateCounter: (payload) => ({
    type: CONSTANTS.SET_MAIN_UPDATE_COUNTER,
    payload,
  }),

  getFileData: (payload) => ({
    type: CONSTANTS.GET_MAIN_FILE_DATA,
    payload,
  }),

  getFindChildren: (payload) => ({
    type: CONSTANTS.GET_FIND_CHILDREN,
    payload,
  }),
  setFindChildren: (payload) => ({
    type: CONSTANTS.SET_FIND_CHILDREN,
    payload,
  }),
  getAddedChildren: (payload) => ({
    type: CONSTANTS.GET_ADDED_CHILDREN,
    payload,
  }),
  setAddedChildren: (payload) => ({
    type: CONSTANTS.SET_ADDED_CHILDREN,
    payload,
  }),
  getAddchild: (payload) => ({
    type: CONSTANTS.GET_ADD_CHILD,
    payload,
  }),
  setAddchild: (payload) => ({
    type: CONSTANTS.SET_ADD_CHILD,
    payload,
  }),
  getCheckChild: (payload) => ({
    type: CONSTANTS.GET_CHECK_CHILD,
    payload,
  }),
  setCheckChild: (payload) => ({
    type: CONSTANTS.SET_CHECK_CHILD,
    payload,
  }),
  getInsurerMobile: (payload) => ({
    type: CONSTANTS.GET_INSURER_MOBILE,
    payload,
  }),
  setInsurerMobile: (payload) => ({
    type: CONSTANTS.SET_INSURER_MOBILE,
    payload,
  }),
  getSendOTPInsurer: (payload) => ({
    type: CONSTANTS.GET_SEND_OTP_INSURER,
    payload,
  }),
  setSendOTPInsurer: (payload) => ({
    type: CONSTANTS.SET_SEND_OTP_INSURER,
    payload,
  }),

  getSwitchUser: (payload) => ({
    type: CONSTANTS.GET_SWITCH_USER,
    payload,
  }),
  setSwitchUser: (payload) => ({
    type: CONSTANTS.SET_SWITCH_USER,
    payload,
  }),

  getOpenUserModal: (payload) => ({
    type: CONSTANTS.GET_MAIN_OPEN_USER_MODAL,
    payload,
  }),
  setOpenUserModal: (payload) => ({
    type: CONSTANTS.SET_MAIN_OPEN_USER_MODAL,
    payload,
  }),

  getTechnicalMessages: (payload) => ({
    type: CONSTANTS.GET_MAIN_TECHICAL_MESSAGE,
    payload,
  }),
  setTechnicalMessages: (payload) => ({
    type: CONSTANTS.SET_MAIN_TECHICAL_MESSAGE,
    payload,
  }),

  getCancelReservation: (payload) => ({
    type: CONSTANTS.GET_MAIN_CANCEL_RESERVATION,
    payload,
  }),

  getAddReservationDocuments: (payload) => ({
    type: CONSTANTS.GET_MAIN_ADD_RESERVATION_DOCUMENTS,
    payload,
  }),
  setAddReservationDocuments: (payload) => ({
    type: CONSTANTS.SET_MAIN_ADD_RESERVATION_DOCUMENTS,
    payload,
  }),

  getQuestionStatus: (payload) => ({
    type: CONSTANTS.GET_MAIN_QUESTION_STATUS,
    payload,
  }),
  setQuestionStatus: (payload) => ({
    type: CONSTANTS.SET_MAIN_QUESTION_STATUS,
    payload,
  }),

  getCanChangePersonalDoctor: (payload) => ({
    type: CONSTANTS.GET_DOCTORS_CAN_CHANGE_PERSONAL_DOC,
    payload,
  }),
  setCanChangePersonalDoctor: (payload) => ({
    type: CONSTANTS.SET_DOCTORS_CAN_CHANGE_PERSONAL_DOC,
    payload,
  }),
  setUpdatePlannedVisitsDoctor: (payload) => ({
    type: CONSTANTS.SET_UPDATE_PLANNED_VISITS_DOCTOR,
    payload,
  }),
  getNotifications: (calledFromHub) => ({
    type: CONSTANTS.GET_NOTIFICATIONS_MAIN,
    payload: calledFromHub,
  }),
  setNotifications: (payload) => ({
    type: CONSTANTS.SET_NOTIFICATIONS_MAIN,
    payload,
  }),
  readNotification: (notificationId, callbackActions = []) => ({
    type: CONSTANTS.READ_NOTIFICATION_MAIN,
    payload: { notificationId, callbackActions },
  }),
  getMainIsOutOfOffice: (payload) => ({
    type: CONSTANTS.GET_MAIN_IS_OUT_OF_OFFICE,
    payload,
  }),
  setMainIsOutOfOffice: (payload) => ({
    type: CONSTANTS.SET_MAIN_IS_OUT_OF_OFFICE,
    payload,
  }),
  getShowSpecialistPopup: () => ({
    type: CONSTANTS.GET_SHOW_SPECIALIST_POPUP,
  }),
  setShowSpecialistPopup: (payload) => ({
    type: CONSTANTS.SET_SHOW_SPECIALIST_POPUP,
    payload,
  }),
  getSendRequestCompensationsReturnedMain: (payload) => ({
    type: CONSTANTS.GET_SEND_REQUEST_COMPESATIONS_RETURNED_MAIN,
    payload,
  }),
  setCompensationsRequestLoadingMain: (payload) => ({
    type: CONSTANTS.SET_COMPENSATIONS_REQUEST_LOADING_MAIN,
    payload,
  }),
  getSentGridDataMain: (payload) => ({
    type: CONSTANTS.GET_SENT_GRID_DATA_MAIN,
    payload,
  }),
  setSentGridDataMain: (payload) => ({
    type: CONSTANTS.SET_SENT_GRID_DATA_MAIN,
    payload,
  }),
  setGridSizeValidateMain: (payload) => ({
    type: CONSTANTS.SET_GRID_SIZE_VALIDATE_MAIN,
    payload,
  }),
  setPolicyId: (payload) => ({
    type: CONSTANTS.SET_POLICY_ID,
    payload,
  }),
  getExtendAppeal: (payload) => ({
    type: CONSTANTS.GET_EXTEND_APPEAL,
    payload,
  }),
  setExtendAppeal: (payload) => ({
    type: CONSTANTS.SET_EXTEND_APPEAL,
    payload,
  }),
  setScrollId: (payload) => ({
    type: CONSTANTS.SET_SCROLL_ID,
    payload,
  }),
};

export default actions;
